import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComplaintV1Filters, ComplaintV1Status, complaintV1Statuses } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-v1-filters',
    templateUrl: './complaint-v1-filters.component.html',
    styleUrls: ['./complaint-v1-filters.component.scss'],
})
export class ComplaintV1FiltersComponent {
    documentNumber = '';
    orderDocumentNumber = '';
    status: ComplaintV1Status | null= null;
    contractorCompanyName = '';

    complaintStatuses = complaintV1Statuses;

    protected _filters: ComplaintV1Filters;

    @Input()
    get filters(): ComplaintV1Filters {
        return this._filters;
    }
    set filters(filters: ComplaintV1Filters) {
        this.setFilters(filters);
    }
    @Input() documentStatuses: ComplaintV1Status[];
    @Input() hasContractorFilter = false;

    @Output() filtersEmitter = new EventEmitter<{
        filters: ComplaintV1Filters;
        reset: boolean;
    }>();

    setFilters(filters: ComplaintV1Filters) {
        if (filters) {
            this._filters = filters;
            this.documentNumber = filters.documentNumber;
            this.orderDocumentNumber = filters.orderDocumentNumber;
            this.status = filters.status;
            this.contractorCompanyName = filters.contractorCompanyName;

        } else {
            this.resetFilters(false);
        }
    }

    handleStatus(value) {
        if (!value || value === 'null') {
            value = null;
        }
        this.status = value;
    }

    emitFilters(reset = false) {
        this.filtersEmitter.emit({
            filters: {
                documentNumber: this.documentNumber,
                orderDocumentNumber: this.orderDocumentNumber,
                status: this.status,
                contractorCompanyName: this.contractorCompanyName,
            },
            reset,
        });
    }

    resetFilters(emit = true) {
        this.documentNumber = '';
        this.contractorCompanyName = '';
        this.status = null;
        if(emit)this.emitFilters(true);
    }
}
